import React from 'react'
import { useSelector } from 'react-redux'
import UserAvatar from 'src/components/UserAvatar/UserAvatar'
import { AvatarSizes } from 'src/enums'
import Trns from 'src/localization/Trns'
import { UserListModel } from 'src/models/user.models'
import { selectUserIdFromState } from 'src/redux/selectors/auth.selectors'
import { css, CSSProp } from 'styled-components'

interface UserAvatarAndNameProps {
  className?: string
  user:
    | UserListModel
    | {
        id: string
        fullNameOrEmail: string
        initials: string
        avatarUrl?: string
        deactivated?: boolean
        truncatedFullNameOrEmail?: string
        hasFullName: boolean
      }
  textCss?: CSSProp
}

const UserAvatarAndName: React.FC<UserAvatarAndNameProps> = (
  props,
): React.ReactElement => {
  const userId = useSelector(selectUserIdFromState)

  return (
    <div
      data-testid={'userAvatarAndName'}
      css={css`
        display: flex;
        flex-direction: row;
        align-items: flex-start;
      `}
    >
      <UserAvatar user={props.user} size={AvatarSizes.Small} />
      <span
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          ${props.textCss};
        `}
      >
        <span
          css={css`
            margin-left: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
          `}
        >
          {props.user?.id === userId ? (
            <Trns
              source={'${userName} (you)'}
              expressions={{
                userName:
                  props.user?.truncatedFullNameOrEmail ||
                  props.user?.fullNameOrEmail,
              }}
            />
          ) : (
            props.user?.truncatedFullNameOrEmail || props.user?.fullNameOrEmail
          )}
        </span>
        {!props.user?.hasFullName && (
          <span
            css={css`
              margin-left: 8px;
              overflow: hidden;
              text-overflow: ellipsis;
            `}
          >
            <Trns source={'(unregistered)'} />
          </span>
        )}
      </span>
    </div>
  )
}

export default UserAvatarAndName
